// Icons.js

import logo from './logo.svg';
import circle from './circle.svg'; 


// You can add more icons here:
// import { ReactComponent as AnotherIcon } from './anotherIcon.svg'; 

const Icons = {
  logo, 
  circle, 
  // AnotherIcon, 
};

export default Icons;